// companies.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// اختياري: عرّف Interface
// export interface Company {
//   id?: number;
//   name: string;
//   specialty?: string;
//   tel?: string;
//   address?: string;
//   contact_email?: string;
//   created_at?: string;
//   updated_at?: string;
// }

@Injectable({ providedIn: 'root' })
export class CompaniesService {
  private base = `${environment.Server_URL}/companies-data`;

  constructor(private http: HttpClient) {}

  // GET /companies-data?per_page=&page=
  getAll(perPage = 10, page = 1): Observable<any> {
    return this.http.get<any>(`${this.base}?per_page=${perPage}&page=${page}`);
  }

  // GET /companies-data/{id}
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.base}/${id}`);
  }

  // POST /companies-data
  create(payload: any /* | Company */): Observable<any> {
    return this.http.post<any>(this.base, payload);
  }

  // PATCH /companies-data/{id}

update(id: number, payload: FormData | any): Observable<any> {
  const isFormData = payload instanceof FormData;

  if (isFormData) {
    payload.append('_method', 'PUT'); // ✨ ده يخلي Laravel يفهم إن الريكوست update
    return this.http.post(`${this.base}/${id}`, payload);
  }

  return this.http.put(
    `${this.base}/${id}`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
}
  // DELETE /companies-data/{id}
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

  // GET /companies-data/search?q=&page=&per_page=
  // q يجري بحث في: name, specialty, tel, address, contact_email
  search(q = '', page = 1, perPage = 10): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    if (q) params = params.set('q', q);

    return this.http.get<any>(`${this.base}/search`, { params });
  }
}
